export { default } from './withArtistFeed';
